import styled, { css } from "styled-components";

import { colors, fontFamily, breakpoints, interaction } from "../../../theme";
import { POINTER_HOVER_MEDIA } from "../../styles/pointer-hover";
import Button from "../form/Button";

const outlinedHover = interaction.button.outlined.hover;

export const BlogReadMoreButton = styled(Button)`
  display: none;
  pointer-events: none;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    ${(props) =>
      props.cardVariant === "wide" &&
      css`
        display: inline-block;
        color: ${colors.black};
        border: 1px solid ${colors.black};
      `}
  }
  @media only screen and (min-width: ${breakpoints.desktop}) {
    display: inline-block;
    color: ${colors.black};
    border: 1px solid ${colors.black};
  }
`;

export const BlogContainer = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  margin: 0;
  cursor: pointer;
  padding: 12px;
  border: none;
  border-radius: 12px;
  background: ${colors.surface};
  transition: background-color 0.2s ease;

  @media ${POINTER_HOVER_MEDIA} {
    &:hover {
      background: ${colors.accent};
    }

    &:hover ${BlogReadMoreButton} {
      background-color: ${outlinedHover.background};
      color: ${outlinedHover.color};
      border-color: ${outlinedHover.border};
    }
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    padding: 14px;
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    max-width: 1080px;
    ${(props) =>
      props.variant === "normal" &&
      css`
        display: block;
        margin: 0;
        height: 520px;
        position: relative;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 18px;
        background: ${colors.surface};

        @media ${POINTER_HOVER_MEDIA} {
          &:hover {
            background: ${colors.accent};
          }
        }
      `}
  }
`;

export const BlogImageWrapper = styled.div`
  height: 99px;
  width: 99px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 120px;
    width: 120px;
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    height: 300px;
    width: auto;
    border-radius: 18px;
    margin: 0px auto 24px;

    ${(props) =>
      props.variant === "wide" &&
      css`
        height: 240px;
      `}
  }
`;

export const BlogContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0 6px;
  margin-left: 12px;
  width: calc(100% - 99px);
  justify-content: flex-start;
  gap: 8px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    width: calc(100% - 120px);
    margin-left: 16px;
  }
  @media only screen and (min-width: ${breakpoints.desktop}) {
    align-items: flex-start;
    justify-content: space-between;
    gap: 0;
    height: ${(props) =>
      props.variant === "wide"
        ? "calc(520px - 300px)"
        : "calc(520px - 300px - 40px - 24px)"};

    padding: 0 28px;
    width: auto;
    margin-left: 0;
  }
`;

export const BlogContent = styled.div``;

export const BlogCategory = styled.span`
  display: none;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    display: block;
    font-size: 14px;
    font-family: ${fontFamily.regular};
    text-transform: capitalize;
  }
`;

export const BlogHeading = styled.div`
  font-size: 14px;
  font-family: ${fontFamily.medium};
  margin: 0;
  color: ${colors.accentContent};

  @media only screen and (min-width: 600px) {
    font-size: 16px;
    font-family: ${fontFamily.bold};
  }
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 20px;
    font-family: ${fontFamily.bold};
  }
`;

export const BlogHelperText = styled.div`
  font-size: 12px;
  font-family: ${fontFamily.regular};
  color: ${colors.grey.darkMedium};

  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 14px;
    font-family: ${fontFamily.regular};
  }
`;
